import { request } from '@/shared/api/request'

export const sendActualSignStaffing = ({data, params}) => {
	return request({ url: 'staff/xml/actual/send', method: 'POST', data: data, params })
}
